
export enum PhotoAddressOption {
    GPSCoordinates = 'GPS Coordinates',
    GPSLocation = 'GPS Location',
    JobAddress = 'Job Address',
    None = 'None'
}

export interface PhotoSettings {
    displayTimestampOnImage: boolean,
    displayReferenceOnImage: boolean,
    photoAddressOption: PhotoAddressOption,
    photoReferenceOptions: PhotoReferenceOption[]
}

export enum PhotoReferenceOption {
    JobNumber = 'Job Number',
    StageNumber = 'Stage Number',
    StageName = 'Stage Name',
    CustomerWo = 'Customer WO'
}